import moment from "moment";
import { type OptionDto } from "../../../autogen/bff-api";

export const exerciseDeadline = (option: OptionDto, shown: OptionDto): string | undefined => {
  if (option.datesSetByHand) return option.deadline ?? undefined;
  const months = option.extension?.exerciseDeadlineMonths;
  if (!shown.startDate || months == null) return undefined;
  return moment(shown.startDate).startOf("day").subtract(1, "day").subtract(months, "months").format("YYYY-MM-DD");
};

export const isBeforeContractStart = (deadline: string | undefined, contractStart: string | null | undefined): boolean =>
  !!deadline && !!contractStart && moment(deadline).startOf("day").isBefore(moment(contractStart).startOf("day"));
